$(document).ready(function () {
    if ($(".en-promocion").length) {
        $(".en-promocion").fadeIn();
        $(".en-promocion").on("click", function () {
            $(this).fadeOut(function () {
                $(this).remove();
            });
        });
    }

    if ($(".en-promocion-12").length) {
        $(".en-promocion-12").fadeIn();
        $(".en-promocion-12").on("click", function () {
            $(this).fadeOut(function () {
                $(this).remove();
            });
        });
    }

    if ($(".en-promocion-11").length) {
        $(".en-promocion-11").fadeIn();
        $(".en-promocion-11").on("click", function () {
            $(this).fadeOut(function () {
                $(this).remove();
            });
        });
    }
});
